module.exports = __webpack_public_path__ + "static/pechuga-rellena-de-espinaca-1-3cc9c3d5d29236d75f455f4c3c03c305.jpg";